import React from 'react';
import { stateIcon, stateTone } from '../../utils/stateIcons';

/**
 * InlineEmpty — the empty state for a box among other boxes (spec §3.12): a rail widget, a
 * filtered list, one panel of a grid. One row on a sunken fill, the height of a list row, so
 * "nothing here yet" never becomes the tallest box on the screen. (A whole page or a whole
 * section uses <PageEmptyState>.)
 *
 *   <InlineEmpty kind="empty" title="Vazifalar yo'q" description="Hammasi tartibda." />
 *   <InlineEmpty icon={<Inbox />} tone="info" title="Xabarlar yo'q" />
 *
 * Props: title, description, kind (what is missing, see utils/stateIcons) | icon (an element),
 * tone (icon chip tone), surface ('sunken' inside a card — the default — or 'card' when it IS the
 * box), action, className.
 */
function InlineEmpty({ title, description, kind, icon, tone, surface = 'sunken', action, className = '' }) {
  const cls = `ui-inline-empty${surface === 'card' ? ' ui-inline-empty--card' : ''} ${className}`.trim();
  const chip = icon || (kind ? stateIcon(kind) : null);
  return (
    <div className={cls} role="status">
      {chip && (
        <span className="ui-icon-chip ui-icon-chip--md" data-tone={tone || stateTone(kind, 'neutral')}>{chip}</span>
      )}
      <div className="ui-inline-empty__text">
        <p className="ui-inline-empty__title">{title}</p>
        {description && <p className="ui-inline-empty__desc">{description}</p>}
      </div>
      {action && <div className="ui-inline-empty__action">{action}</div>}
    </div>
  );
}

export default InlineEmpty;
